export default "__VITE_PUBLIC_ASSET__ab086146__"